import type { ComponentProps } from 'react';
import { captureFlags } from '../../configure/flags-facade';
import { DesktopBars as LegacyDesktopBars } from './legacy/DesktopBars';
import { DesktopBars as OptimizedDesktopBars } from './optimized/DesktopBars';

/**
 * SCR-6633 rollout switch: ON renders the compositor-backed optimized bars,
 * OFF the pre-SCR-6633 implementation (byte-identical under `legacy/`).
 */
export const DesktopBars = (props: ComponentProps<typeof OptimizedDesktopBars>) =>
  captureFlags.useIsOptimizedAudioBarsEnabled() ? (
    <OptimizedDesktopBars {...props} />
  ) : (
    <LegacyDesktopBars {...props} />
  );
